import { component, computedThrottle } from '../../../decorators';

const THROTTLE_TIME = 1000;

@component
export default class VerticalScroll {
   x = null
   pushed = false

   mounted() {
      this.$el.addEventListener('mousedown', this._onMouseDown);
   }

   _onMouseDown(e) {
      document.addEventListener('mouseup',   this._onMouseUp);
      document.addEventListener('mousemove', this._onMouseMove);

      this.x = e.clientX;
      this.pushed = true;
   }

   _onMouseMove(e) {
      const x = e.clientX;
      this.$el.scrollLeft -= x - this.x;
      this.x = x;
   }

   _onMouseUp() {
      document.removeEventListener('mouseup',   this._onMouseUp);
      document.removeEventListener('mousemove', this._onMouseMove);
      this.pushed = false;
   }

   @computedThrottle(THROTTLE_TIME)
   width() {
      const rect = this.$el.getBoundingClientRect();
      return rect.width || rect.right - rect.left;
   }

   scrollTo(to, atCenter = false) {
      if (atCenter) {
         to -= _halfOf(this.width());
      }
      this.$el.scrollLeft = to;
   }

   destroyed() {
      this._onMouseUp();
      this.$el.removeEventListener('mousedown', this._onMouseDown);
   }
}


function _halfOf(num) {
   // eslint-disable-next-line no-magic-numbers
   return Math.round( num / 2 );
}
